import { Route, Routes } from "react-router";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { routes } from "@/routes";
import NotFoundPage from "@/routes/not-found/page";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={<route.component />} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
